module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-16.2477ea32.png";